export const SHARDS = [
    'steam',
    'xbox',
    'kakao',
]



// WEBPACK FOOTER //
// ./src/models/Shards.js